import { BrowserRouter as Router } from "react-router-dom"
import { JWTProvider } from "./contexts/JWTContext"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { BASE_ROUTE } from "./config/constant"
import routes, { renderRoutes } from "./routes"
import ChatProvider from "./assets/js/features/chat/state/context/ChatProvider"
import ErrorBoundary from "./assets/js/app/errorBoundary/ErrorBoundary"

const App = (): JSX.Element => {
  return (
    <>
      <Router>
        <ErrorBoundary>
          <JWTProvider>
            <ChatProvider>
              {renderRoutes(routes)}
              <ToastContainer />
            </ChatProvider>
          </JWTProvider>
        </ErrorBoundary>
      </Router>
    </>
  )
}

export default App
